import React from 'react';
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import CircularProgress from "@material-ui/core/CircularProgress";
import BasicButton from '../../../SharedComponents/BasicButton/BasicButton';
import BasicTextArea from '../../../SharedComponents/BasicTextArea/BasicTextArea';
import BasicLabel from '../../../SharedComponents/BasicLabel/BasicLabel';
import { validateAlpVarCharNumOnlyWithSpace } from '../../../../Common/Helper';
import messages from '../../../../Common/Messages.json';
import sizeLimit from '../../../../Common/SizeLimits.json';
import { submissionWorkflowMockData } from './Config';
import ScripterService from '../../../../services/service';
import * as Constants from '../../../../constants/constants';
import { withUserContext } from '../../../../contexts/UserContext';

class ReviseSubmission extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reviseSubmissionDetails: submissionWorkflowMockData,
            postInitiated: false,
            isPosting: false
        }
    }

    handleGeneralEdit = (field, value) => {
        let newValue = value;
        this.setState(prevState => ({
            reviseSubmissionDetails: {
                ...prevState.reviseSubmissionDetails,
                [field]: newValue
            },
            postInitiated: false
        }))
    }

    isValidErrorFlags = () => {
        let canSubmit = this.state.reviseSubmissionDetails?.comments ? this.state.reviseSubmissionDetails?.comments?.length <= sizeLimit.limitchar500 : true;
        return canSubmit;
    }

    handleReviseSubmit = () => {
        this.setState({ postInitiated: true })
        if (this.isValidErrorFlags()) {
            this.postReviseSubmission()
        } else {
            console.log('Submission Failed');
        }
    }

    postReviseSubmission = () => {
        this.setState({ isPosting: true })
        let postJson = this.state.reviseSubmissionDetails;
        postJson.submission_id = this.props?.submissionId;
        postJson.action_label = "REVISE SUBMISSION";
        postJson.created_at = new Date().toLocaleString('en-US', { hour12: false});
        console.log('postJson', postJson);
        // POST API call
        ScripterService.postDataParams(Constants.scripterServiceBaseUrl + '/submissionCoverageWorkflow', postJson,
            this.props.userContext.active_tenant.tenant_id, this.props?.divisionId)
            .then(response => {
                if (response.data.error) {
                    this.setState({ isPosting: false })
                    this.props.setPostFlag(false);
                    this.props.fieldChanged(true, "fail");
                } else {
                    this.setState({ postInitiated: false, isPosting: false });
                    this.props.setPostFlag(false);
                    this.props.fieldChanged(true, "success", "submission", "revise_submission");
                }
            },
                (err) => {
                    console.log("Error in posting revise submission:", err)
                    this.setState({ postInitiated: false, isPosting: false });
                    this.props.setPostFlag(false);
                    this.props.fieldChanged(true, "fail");
                })
    }

    render() {
        return (
            <MDBContainer fluid className="revise-submission-container">
                <MDBRow className="revise-text">
                    <BasicLabel 
                        text={`This submission will be sent back to ${this.props?.executive || '-'} for revision.`} 
                    />
                </MDBRow>
                <MDBRow>
                    <MDBCol md={12}>
                        <BasicTextArea
                            value={this.state.reviseSubmissionDetails?.comments || null}
                            label={"Comments"}
                            className={"textArea"}
                            rows={3}
                            limit={sizeLimit.limitchar500}
                            limitWarning={messages.exceed500CharacterWarning || ""}
                            onChange={(e) => validateAlpVarCharNumOnlyWithSpace(e.target.value) ?
                                this.handleGeneralEdit('comments', e.target.value) : null}
                            typedCharCount={this.state.reviseSubmissionDetails?.comments?.length || 0}
                            showCharCount={true}
                        />
                    </MDBCol>
                </MDBRow>
                <MDBRow className="mt-1">
                    <MDBCol md={7}></MDBCol>
                    <MDBCol md={5}>
                        <MDBRow className='mt5'>
                            <MDBCol md={4} className="sub-revise-cancel">
                                <BasicButton
                                    variant="outlined"
                                    text={"Cancel"}
                                    onClick={this.props?.handleClose}
                                />
                            </MDBCol>
                            <MDBCol md={8} className="submission-revise-btn">
                                <BasicButton
                                    icon="share"
                                    text={this.state.isPosting ? <CircularProgress color="inherit" size={20} /> : "Return for Revision"}
                                    disabled={this.state.reviseSubmissionDetails?.comments ? false : true}
                                    onClick={this.handleReviseSubmit}
                                />
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        );
    }
}

export default withUserContext(ReviseSubmission)